import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/GlobalStyles';
import { settingsService } from '../../services/settingsService';
import { Button } from '../../components/Button';
import { Input, Label, FormGroup, ErrorMessage } from '../../components/Input';
import { toast } from 'react-toastify';

const Container = styled.div``;

const Title = styled.h1`
  color: ${colors.primary};
  margin-bottom: 30px;
`;

const Card = styled.div`
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px ${colors.shadow};
  max-width: 600px;
  margin-bottom: 20px;
`;

const CardTitle = styled.h2`
  color: ${colors.primary};
  font-size: 20px;
  margin-bottom: 20px;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${colors.border};
  margin: 30px 0;
`;

export const AdminSettings = () => {
  const [emailData, setEmailData] = useState({
    email: ''
  });

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    
    if (!emailData.email) {
      setErrors({ email: 'Email alanı zorunludur' });
      return;
    }

    try {
      setLoading(true);
      await settingsService.updateAdminEmail(emailData.email);
      toast.success('Email başarıyla güncellendi');
      setEmailData({ email: '' });
    } catch (error) {
      toast.error(error.response?.data?.error || 'Email güncellenemedi');
      setErrors({ email: error.response?.data?.error });
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      setErrors({ password: 'Tüm alanlar zorunludur' });
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setErrors({ password: 'Yeni şifreler eşleşmiyor' });
      return;
    }

    if (passwordData.newPassword.length < 6) {
      setErrors({ password: 'Şifre en az 6 karakter olmalıdır' });
      return;
    }

    try {
      setLoading(true);
      await settingsService.updateAdminPassword(
        passwordData.currentPassword,
        passwordData.newPassword
      );
      toast.success('Şifre başarıyla güncellendi');
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
      toast.error(error.response?.data?.error || 'Şifre güncellenemedi');
      setErrors({ password: error.response?.data?.error });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Title>Ayarlar</Title>

      <Card>
        <CardTitle>Email Güncelle</CardTitle>
        <form onSubmit={handleEmailSubmit}>
          <FormGroup>
            <Label>Yeni Email</Label>
            <Input
              type="email"
              value={emailData.email}
              onChange={(e) => setEmailData({ email: e.target.value })}
              placeholder="yeni@email.com"
            />
            {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
          </FormGroup>
          <Button type="submit" disabled={loading}>
            Email Güncelle
          </Button>
        </form>
      </Card>

      <Card>
        <CardTitle>Şifre Güncelle</CardTitle>
        <form onSubmit={handlePasswordSubmit}>
          <FormGroup>
            <Label>Mevcut Şifre</Label>
            <Input
              type="password"
              value={passwordData.currentPassword}
              onChange={(e) => setPasswordData({
                ...passwordData,
                currentPassword: e.target.value
              })}
              placeholder="••••••••"
            />
          </FormGroup>

          <FormGroup>
            <Label>Yeni Şifre</Label>
            <Input
              type="password"
              value={passwordData.newPassword}
              onChange={(e) => setPasswordData({
                ...passwordData,
                newPassword: e.target.value
              })}
              placeholder="••••••••"
            />
          </FormGroup>

          <FormGroup>
            <Label>Yeni Şifre (Tekrar)</Label>
            <Input
              type="password"
              value={passwordData.confirmPassword}
              onChange={(e) => setPasswordData({
                ...passwordData,
                confirmPassword: e.target.value
              })}
              placeholder="••••••••"
            />
          </FormGroup>

          {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}

          <Button type="submit" disabled={loading}>
            Şifre Güncelle
          </Button>
        </form>
      </Card>
    </Container>
  );
};

